import React, { useState } from 'react';
import { LOGO_SVG } from '../assets/svgData';
import type { GameMode } from '../game/types';
import type { OnlineGameMode } from '../network/types';

interface MainMenuProps {
  hasActiveGame: boolean;
  activeGameMode?: GameMode;
  onResumeGame: () => void;
  onStartClassic: () => void;
  onStartBlitz: () => void;
  onStartClashLocal: () => void;
  onOpenOnlineLobby: (mode: OnlineGameMode) => void;
  onOpenLeaderboard: () => void;
  onOpenHelp: () => void;
}

export const MainMenu: React.FC<MainMenuProps> = ({
  hasActiveGame,
  activeGameMode = 'classic',
  onResumeGame,
  onStartClassic,
  onStartBlitz,
  onStartClashLocal,
  onOpenOnlineLobby,
  onOpenLeaderboard,
  onOpenHelp,
}) => {
  const [showOnlineMenu, setShowOnlineMenu] = useState(false);

  const getResumeLabel = () => {
    if (activeGameMode === 'blitz') return 'Resume Blitz';
    if (activeGameMode === 'versus') return 'Resume Clash';
    return 'Resume Classic';
  };

  return (
    <div className="menu-screen">
      <div className="menu-header">
        <div className="logo-container" dangerouslySetInnerHTML={{ __html: LOGO_SVG }} />
        <h1 className="menu-title">{showOnlineMenu ? 'Online Modes 🌐' : 'Find Sets!'}</h1>
      </div>

      <div className="menu-buttons">
        {showOnlineMenu ? (
          <>
            <button
              className="btn btn-clash-online"
              id="btn-online-clash"
              onClick={() => {
                setShowOnlineMenu(false);
                onOpenOnlineLobby('clash');
              }}
            >
              Clash 🌐
            </button>
            <button
              className="btn btn-race-online"
              id="btn-online-race"
              onClick={() => {
                setShowOnlineMenu(false);
                onOpenOnlineLobby('race');
              }}
            >
              Race 🌐
            </button>
            <button
              className="btn btn-blitz-online"
              id="btn-online-blitz"
              onClick={() => {
                setShowOnlineMenu(false);
                onOpenOnlineLobby('blitz');
              }}
            >
              Blitz 🌐
            </button>
            <button
              className="btn btn-secondary"
              id="btn-online-back"
              onClick={() => setShowOnlineMenu(false)}
            >
              Back
            </button>
          </>
        ) : (
          <>
            {hasActiveGame && (
              <button className="btn btn-resume" id="btn-resume-game" onClick={onResumeGame}>
                {getResumeLabel()}
              </button>
            )}
            <button className="btn btn-primary" id="btn-start-classic" onClick={() => onStartClassic()}>
              {hasActiveGame && activeGameMode === 'classic' ? 'New Classic Game' : 'Classic Mode'}
            </button>
            <button className="btn btn-blitz" id="btn-start-blitz" onClick={() => onStartBlitz()}>
              {hasActiveGame && activeGameMode === 'blitz' ? 'New Blitz Game' : 'Blitz Mode'}
            </button>
            <button className="btn btn-versus" id="btn-start-clash-local" onClick={() => onStartClashLocal()}>
              {hasActiveGame && activeGameMode === 'versus' ? 'New Clash Game' : 'Clash'}
            </button>
            <button
              className="btn btn-online"
              id="btn-open-online-menu"
              onClick={() => setShowOnlineMenu(true)}
            >
              Online 🌐
            </button>
            <button className="btn btn-secondary" id="btn-view-leaderboard" onClick={onOpenLeaderboard}>
              Leaderboard
            </button>
            <button className="btn btn-secondary" id="btn-view-help" onClick={onOpenHelp}>
              How to Play
            </button>
          </>
        )}
      </div>
    </div>
  );
};
